import React, { useEffect, createContext, useState } from "react";
import {
  Switch,
  Route,
  BrowserRouter,
  useHistory,
  useLocation,
} from "react-router-dom";
import "./App.scss";
import { Redirect } from "react-router-dom";
import Cookies from "js-cookie";
import Home from "./pages/Home";
import $axios from "./services/axios";
import { Modal } from "antd";

const ReachableContext = createContext(null);
const config = {
  title: "Token không hợp lệ!",
  maskClosable: false,
  footer: null,
  content: (
    <>
      <ReachableContext.Consumer>
        {(name) => `Có lỗi xảy ra vui lòng trở về trang chủ`}
      </ReachableContext.Consumer>
    </>
  ),
};

const App = () => {
  const [modal, contextHolder] = Modal.useModal();
  const queryParams = new URLSearchParams(window.location.search);
  const verifyToken =
    queryParams.get("VerifyToken") || queryParams.get("verifyToken");
  const [token, setToken] = useState(
    verifyToken ? null : localStorage.getItem("planeToken")
  );
  const history = useHistory();
  const location = useLocation();

  const decodeToken = async () => {
    // Lấy token từ URL
    try {
      if (verifyToken) {
          localStorage.removeItem("planeToken");
          const res = await $axios.$post(`${process.env.REACT_APP_BASE_URL}/v1/auth/login-lichviet`, {
            VerifyToken: verifyToken,
            TypeService: "flight"
          });
          localStorage.setItem("planeToken", res.data.data.accesstoken);
          const userInfo = res?.data?.data?.userinfo;
          if (userInfo) {
              userInfo.phone = userInfo?.phone?.replace(/^84/, "0");
              sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
          }
          queryParams.delete("VerifyToken");
          setToken(res.data.data.accesstoken);
          history.replace({
            pathname: location.pathname,
            search: queryParams.toString(),
          });
        }
        else {
          if (!token) {
            modal.error(config);
          }
        }
     
    } catch (error) {}
  };

  useEffect(() => {
    decodeToken();
  }, []);

  return (
    <>
      <Switch>
        <Redirect exact from="/" to={"/vemaybay"} />
        <Route
          exact
          path={"/vemaybay"}
          render={(props) => <Home {...props} token={token} />}
        />
        <Redirect to={"/vemaybay"} />
      </Switch>
      {contextHolder}
    </>
  );
};

export default App;
